import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const SECTION_TITLE_STYLE = {
	fontWeight: 500,
	fontSize: '14px',
	marginBottom: '12px',
};

const HINT_STYLE = {
	fontSize: '12px',
	color: '#9ea0a5',
	lineHeight: '1.4',
	marginTop: '-4px',
	marginBottom: '4px',
};

const getAddressFields = (): ItemScheme[] => [
	{
		type: MagicField.TEXT_FIELD,
		key: 'street',
		title: 'base.shared.street',
		settings: { required: true },
	},
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.TEXT_FIELD,
				key: 'descriptiveNumber',
				title: 'base.shared.descriptiveNumber',
				settings: { required: true },
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'guideNumber',
				title: 'base.shared.guideNumber',
			},
		],
	},
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.TEXT_FIELD,
				key: 'city',
				title: 'base.shared.city',
				settings: { required: true },
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'postCode',
				title: 'base.shared.postCode',
				settings: { required: true },
			},
		],
	},
];

export const discourseTravelFormScheme: ItemScheme[] = [
	{
		type: MagicField.NUMBER,
		key: 'distanceKm',
		title: 'component.discourseTravel.distanceKm',
		settings: { required: true },
	},
	{
		type: MagicField.TEXT,
		title: 'component.discourseTravel.distanceKmHint',
		settings: {
			labelStyle: HINT_STYLE,
		},
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.CONTAINER,
				key: 'fromAddress',
				settings: {
					style: { paddingRight: '12px' },
				},
				children: [
					{
						type: MagicField.TEXT,
						title: 'component.discourseTravel.from',
						settings: {
							labelStyle: SECTION_TITLE_STYLE,
						},
					},
					...getAddressFields(),
				],
			},
			{
				type: MagicField.CONTAINER,
				key: 'toAddress',
				settings: {
					style: { paddingLeft: '12px' },
				},
				children: [
					{
						type: MagicField.TEXT,
						title: 'component.discourseTravel.to',
						settings: {
							labelStyle: SECTION_TITLE_STYLE,
						},
					},
					...getAddressFields(),
				],
			},
		],
	},
];
